/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetEnvironmentReleaseRulesForFlagPathParams = NonNullable<
  operations['internalGetEnvironmentReleaseRulesForFlag']['parameters']['path']
>;

export type InternalGetEnvironmentReleaseRulesForFlagQueryParams = NonNullable<
  operations['internalGetEnvironmentReleaseRulesForFlag']['parameters']['query']
>;

export interface Input extends InternalGetEnvironmentReleaseRulesForFlagPathParams {
  apiVersion?: string;
  query?: InternalGetEnvironmentReleaseRulesForFlagQueryParams;
}

export async function internalGetEnvironmentReleaseRulesForFlag(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/flags/{flagKey}/environments/{environmentKey}/audience-phase-releases',
    {
      params: { path, query },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
